import React from 'react'
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { PurchasedTokensStyle as styles } from "../../purchaseHistory.tailwind";
import OrderDetailsTable from "../../OrderDetailsTable";
import { calculateTokenDetails, zoneImage } from './purchasedHistory.data';
// import { calculateSubtotal } from './purchasedHistory.data';

const PurchasedTokenTableList = ({ item, expandedZones }) => {
    // const tokenDetails = calculateTokenDetails(item.zones);
    // Order subtotal for individual zones
    // const subtotal = calculateSubtotal(tokenDetails);

    return (
        <div className={styles.orderDetailsContainer}>
            <div className={styles.detailsInnerContainer}>
                {/* Token image according to zone category */}
                <div className={styles.tokenImageContainer} style={{ backgroundColor: "var(--themeColor)", border: "1px solid var(--cubeborder)" }} >
                    <figure className={styles.imageContainer}>
                        <img
                            src={zoneImage(item.zoneCategoryName)}
                            alt={item.zoneCategoryName}
                            className={styles.tokenImage}
                        />
                    </figure>
                    <span className={styles.headers}>{item.zoneCategoryName}</span>
                </div>

                {/* Zone category name and zone names */}
                <div className={styles.tokenDetails}>
                    {/* <div
                        className={styles.subDetails}
                    // onClick={() => handleToggle(item.zoneCategoryName)}
                    >
                        <div className={styles.details}>
                            <span className={styles.headers}>{item.zoneCategoryName}</span>
                            <span className="zone-infobox">
                                {item.zones.map((z) => z.zoneName).join(", ")}
                            </span>
                        </div> */}

                        {/* Token quantity and toggle button for each token details */}
                        {/* <div className={styles.details}>
                            <div className="flex">
                                <span className={styles.headers}>Quantity</span> */}
                                {/* <button>
                            {expandedZones[item.zoneCategoryName] ? (
                                    <ExpandLessIcon htmlColor="#fff" sx={{ fontSize: "22px" }} />
                                ) : (
                                    <ExpandMoreIcon htmlColor="#fff" sx={{ fontSize: "22px" }} />
                                )
                            }
                        </button> */}
                            {/* </div>

                            <span className="text-center">{item.tokenQuantity || "N/A"}</span>
                        </div> */}

                        {/* Subtotal */}
                        {/* <div className={styles.subtotal}>
                            <span className={styles.headers}>Subtotal</span>
                            <span>${calculateSubtotal(item.zones).toFixed(2)}</span>
                        </div> */}
                    {/* </div> */}

                    {expandedZones[item.zoneCategoryName] && (
                        // Order details table for each zone category
                        <OrderDetailsTable tokenDetails={calculateTokenDetails(item.zones)} />
                    )}
                </div>
            </div>
        </div>
    );
}

export default PurchasedTokenTableList